import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  Row,
  Col,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
} from 'reactstrap';

import { callApi, formatDate, formatAmount, _toDash } from '../../utils';
import { showError } from '../../actions/notificationActions';

import SearchForm from '.././SearchForm';
import DataTable, { PageHeader } from '../DataTable';

class List extends Component {
  state = {
    records: [],
    query: '',
    page: 1,
    limit: 15,
    loading: false,
    meta: { pages: 1 },
    statusDropDownOpen: false,
    selectedStatus: null,
  };

  componentWillMount() {
    this.loadTransactions();
  }

  startLoad = () => this.setState({ loading: true });
  stopLoad = () => this.setState({ loading: false });

  scrollToTop = () =>
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);

  loadTransactions = (e) => {
    // Event may be passed in from search form
    if (e) e.preventDefault();

    const { query, page, limit, selectedStatus = null } = this.state;

    this.startLoad();

    let data = { page, limit };

    if (selectedStatus) {
      data = { ...data, status: selectedStatus };
    }

    if (query) {
      data = { ...data, q: query };
    }
    callApi(`/refunds`, data)
      .then(({ data = [], meta }) => {
        this.setState({ loading: false, records: data, meta });
        this.scrollToTop();
      })
      .catch((err) => {
        this.stopLoad();
        this.props.dispatch(showError(err));
      });
  };

  setPage = (page) => {
    if (page) {
      this.setState({ page }, () => {
        this.loadTransactions();
      });
    }
  };

  setQuery = (e) => {
    this.setState({ query: e.target.value });
  };

  openTransaction = (id) => {
    this.props.history.push(`/refunds/${id}`);
  };

  setSelectedStatus = (status) => {
    this.setState(
      {
        selectedStatus: status,
      },
      () => {
        this.loadTransactions();
      }
    );
  };

  render() {
    const { query, records, page, loading, limit, meta } = this.state;

    const hasResults = records.length > 0;
    return (
      <div className="container-fluid">
        <Row className="mt-3 mt-md-4">
          <Col xs={12}>
            <PageHeader title="Refunds" subtitle={<>Refunds - Page {page}</>}>
              <div className="d-flex justify-content-end">
                <div className="mr-3">
                  <SearchForm
                    value={query}
                    onChange={this.setQuery}
                    onSearch={this.loadTransactions}
                    loading={loading}
                  />
                </div>
                <Dropdown
                  isOpen={this.state.statusDropDownOpen}
                  toggle={
                    loading
                      ? null
                      : (e) => {
                          this.setState({
                            statusDropDownOpen: !this.state.statusDropDownOpen,
                          });
                        }
                  }
                  disabled={loading}
                >
                  <DropdownToggle caret>
                    {this.state.selectedStatus
                      ? this.state.selectedStatus
                      : 'ANY'}
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem
                      tag="a"
                      active={this.state.selectedStatus === null ? true : false}
                      onClick={() => this.setSelectedStatus(null)}
                    >
                      ANY
                    </DropdownItem>
                    <DropdownItem
                      tag="a"
                      active={
                        this.state.selectedStatus === 'PROCESSED' ? true : false
                      }
                      onClick={() => this.setSelectedStatus('PROCESSED')}
                    >
                      PROCESSED
                    </DropdownItem>
                    <DropdownItem
                      tag="a"
                      active={
                        this.state.selectedStatus === 'PENDING' ? true : false
                      }
                      onClick={() => this.setSelectedStatus('PENDING')}
                    >
                      PENDING
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
            </PageHeader>

            <DataTable
              minWidth={900}
              loading={loading}
              page={page}
              total={meta.pages}
              onPageChange={this.setPage}
              showPagination={hasResults}
            >
              <thead className="text-primary">
                <tr>
                  <th>No.</th>
                  <th>Date</th>
                  <th>Customer</th>
                  <th>Method</th>
                  <th>Order Reference</th>
                  <th>Payment Reference</th>
                  <th>Processor</th>
                  {/* <th>Name</th>
                      <th>Phone</th> */}
                  <th>Amount</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                {records.map((t, i) => (
                  <tr onClick={() => this.openTransaction(t.id)} key={t.id}>
                    <td>{loading ? '—' : i + 1 + (page - 1) * limit}</td>
                    <td>{formatDate(t.created_at)}</td>
                    {/* order/customer/payment are nullable on a refund
                                — an unmatched or orphaned row has no order, and
                                dereferencing it took the whole page down. */}
                    <td>{(t.customer || {}).name || 'N/A'}</td>
                    <td>{t.method}</td>
                    <td>{(t.order || {}).order_id || 'N/A'}</td>
                    <td>{(t.payment || {}).reference || 'N/A'}</td>
                    <td>{(t.payment || {}).processor || 'N/A'}</td>
                    {/* <td>{t.paymentTransaction.name}</td> */}
                    {/* <td>{t.paymentTransaction.phone}</td> */}
                    <td>{formatAmount(t.amount)}</td>
                    <td>{_toDash(t.status)}</td>
                  </tr>
                ))}
              </tbody>
            </DataTable>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect()(List);
